const getServiceProvider = state => state.serviceProvider.serviceProvider;

export default getServiceProvider;